import { Dispatch, SetStateAction, useCallback } from 'react';

import {
	INITIAL_AUDIO_STATE,
	MIN_SEEK_VALUE,
	SKIP_SECONDS,
} from '@/components/emotion-detector/AudioPlayer/constants';
import { CurrentAudio } from '@/components/emotion-detector/AudioPlayer/types';

interface UseAudioControlsProps {
	currentAudio: CurrentAudio;
	setCurrentAudio: Dispatch<SetStateAction<CurrentAudio>>;
}

export function useAudioControls({ currentAudio, setCurrentAudio }: UseAudioControlsProps) {
	const handlePlayPause = useCallback(() => {
		if (currentAudio.element) {
			if (currentAudio.isPlaying) {
				currentAudio.element.pause();
				setCurrentAudio(prev => ({ ...prev, isPlaying: false }));
			} else {
				currentAudio.element.play().catch(() => {
					// Handle play error silently
				});
				setCurrentAudio(prev => ({ ...prev, isPlaying: true }));
			}
		}
	}, [currentAudio.element, currentAudio.isPlaying, setCurrentAudio]);

	const handleBack15 = useCallback(() => {
		if (currentAudio.element) {
			// TODO: refactor this code to follow best practices
			// eslint-disable-next-line react-hooks/immutability
			currentAudio.element.currentTime = Math.max(
				MIN_SEEK_VALUE,
				currentAudio.element.currentTime - SKIP_SECONDS,
			);
		}
	}, [currentAudio.element]);

	const handleForward15 = useCallback(() => {
		if (currentAudio.element && currentAudio.duration) {
			// TODO: refactor this code to follow best practices
			// eslint-disable-next-line react-hooks/immutability
			currentAudio.element.currentTime = Math.min(
				currentAudio.duration,
				currentAudio.element.currentTime + SKIP_SECONDS,
			);
		}
	}, [currentAudio.element, currentAudio.duration]);

	const handleStop = useCallback(() => {
		if (currentAudio.element) {
			currentAudio.element.pause();
			// TODO: refactor this code to follow best practices
			// eslint-disable-next-line react-hooks/immutability
			currentAudio.element.currentTime = MIN_SEEK_VALUE;
			setCurrentAudio(INITIAL_AUDIO_STATE);
		}
	}, [currentAudio.element, setCurrentAudio]);

	const handleSeek = useCallback(
		(time: number) => {
			if (currentAudio.element) {
				// TODO: refactor this code to follow best practices
				// eslint-disable-next-line react-hooks/immutability
				currentAudio.element.currentTime = time;
				setCurrentAudio(prev => ({ ...prev, currentTime: time }));
			}
		},
		[currentAudio.element, setCurrentAudio],
	);

	return {
		handlePlayPause,
		handleBack15,
		handleForward15,
		handleStop,
		handleSeek,
	};
}
